(function() {
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;
  
  const sectionId = productGrid.dataset.id;
  if (!sectionId) return;
  
  
  function getCurrentColumns() {
    if (!productGrid) return 3;
    
    if (productGrid.classList.contains('grid--2-col-desktop')) {
      return 2;
    } else if (productGrid.classList.contains('grid--3-col-desktop')) {
      return 3;
    }
    return 3;
  }
  
  function updateSeparatorLines() {
		if (!productGrid) return

		const is2Col = productGrid.classList.contains('grid--2-col-desktop')
		const is3Col = productGrid.classList.contains('grid--3-col-desktop')
		const columns = is2Col ? 2 : is3Col ? 3 : 3

		const items = Array.from(productGrid.querySelectorAll('.grid__item:not(.ec-custom-block)'))

		if (items.length <= 1) {
			items.forEach((item) => {
				item.classList.remove('ec-has-next-item')
			})
			const allItems = productGrid.querySelectorAll('.grid__item')
			allItems.forEach((item) => {
				item.classList.remove('ec-has-next-item')
			})
			return
		}

		items.forEach((item, index) => {
			const itemPosition = index + 1
			const isLastInRow = columns === 2 ? itemPosition % 2 === 0 : itemPosition % 3 === 0

			if (isLastInRow) {
				item.classList.remove('ec-has-next-item')
				return
			}

			let nextProductItem = null
			let currentElement = item.nextElementSibling

			while (currentElement) {
				if (currentElement.classList.contains('grid__item')) {
					if (!currentElement.classList.contains('ec-custom-block')) {
						nextProductItem = currentElement
						break
					}
				}
				currentElement = currentElement.nextElementSibling
			}

			if (nextProductItem) {
				const nextIndex = items.indexOf(nextProductItem)
				const nextPosition = nextIndex + 1
				const nextIsLastInRow = columns === 2 ? nextPosition % 2 === 0 : nextPosition % 3 === 0

				const isSameRow =
					columns === 2
						? Math.floor((itemPosition - 1) / 2) === Math.floor((nextPosition - 1) / 2)
						: Math.floor((itemPosition - 1) / 3) === Math.floor((nextPosition - 1) / 3)

				if (isSameRow && !item.classList.contains('ec-custom-block')) {
					item.classList.add('ec-has-next-item')
				} else {
					item.classList.remove('ec-has-next-item')
				}
			} else {
				item.classList.remove('ec-has-next-item')
			}
		})
	}

	window.updateSeparatorLines = updateSeparatorLines

	function reorganizeCustomBlocks() {
		if (!productGrid) return

		const currentColumns = getCurrentColumns()
		const isMobile = window.innerWidth <= 989
		const isMobile2Col = productGrid.classList.contains('grid--2-col-tablet-down')
		const isMobile1Col = productGrid.classList.contains('grid--1-col-tablet-down')

		const allItems = Array.from(productGrid.querySelectorAll('.grid__item'))
		const productItems = allItems.filter((item) => !item.classList.contains('ec-custom-block'))
		const videoBlock = productGrid.querySelector('.ec-video-block')
		const promoBlocks = Array.from(productGrid.querySelectorAll('.ec-promo-card'))

		if (!videoBlock && promoBlocks.length === 0) return

		function getBlockPosition(block) {
			if (isMobile && isMobile1Col) {
				return parseInt(
					block.getAttribute('data-position-mobile-1col') || block.dataset.positionMobile1col || '3'
				)
			} else if (isMobile && isMobile2Col) {
				return parseInt(
					block.getAttribute('data-position-mobile-2col') || block.dataset.positionMobile2col || '3'
				)
			} else if (currentColumns === 3) {
				return parseInt(block.getAttribute('data-position-3col') || block.dataset.position3col || '5')
			}
			return parseInt(block.getAttribute('data-position-2col') || block.dataset.position2col || '3')
		}

		// Vídeo (único) + todos os cards promocionais
		const customBlocks = []
		if (videoBlock) customBlocks.push(videoBlock)
		promoBlocks.forEach((b) => customBlocks.push(b))

		const entries = customBlocks.map((block) => ({
			block,
			position: getBlockPosition(block),
			mobileCols: block.getAttribute('data-mobile-columns') || block.dataset.mobileColumns || '1'
		}))

		entries.forEach(({ block }) => {
			if (block.parentNode) block.parentNode.removeChild(block)
		})

		if (productItems.length > 0) {
			const blocksToInsert = entries.filter((e) => productItems.length >= e.position)

			blocksToInsert.sort((a, b) => b.position - a.position)

			blocksToInsert.forEach(({ block, position, mobileCols }) => {
				const insertAfterIndex = position - 1

				if (insertAfterIndex >= 0 && insertAfterIndex < productItems.length) {
					const insertAfterItem = productItems[insertAfterIndex]

					if (insertAfterItem && insertAfterItem.parentNode) {
						if (isMobile && isMobile2Col && mobileCols === '1') {
							const productsBefore = insertAfterIndex
							const productsBeforeMod = productsBefore % 2
							const productsAfter = productItems.length - insertAfterIndex - 1

							if (productsAfter === 0 || productsBeforeMod === 0) {
								const nextProductIndex = insertAfterIndex + 1
								if (nextProductIndex < productItems.length) {
									const nextProduct = productItems[nextProductIndex]
									if (nextProduct && nextProduct.parentNode) {
										insertAfterItem.parentNode.insertBefore(block, nextProduct)
									} else {
										insertAfterItem.parentNode.appendChild(block)
									}
								} else {
									insertAfterItem.parentNode.appendChild(block)
								}
							} else {
								const lastItem = productItems[productItems.length - 1]
								if (lastItem && lastItem.parentNode) {
									lastItem.parentNode.appendChild(block)
								}
							}
						} else {
							const nextProductIndex = insertAfterIndex + 1
							if (nextProductIndex < productItems.length) {
								const nextProduct = productItems[nextProductIndex]
								if (
									nextProduct &&
									nextProduct.parentNode &&
									nextProduct.parentNode === insertAfterItem.parentNode
								) {
									insertAfterItem.parentNode.insertBefore(block, nextProduct)
								} else {
									let nextSibling = insertAfterItem.nextElementSibling
									while (
										nextSibling &&
										nextSibling.classList &&
										nextSibling.classList.contains('ec-custom-block')
									) {
										nextSibling = nextSibling.nextElementSibling
									}
									if (nextSibling && !nextSibling.classList.contains('ec-custom-block')) {
										insertAfterItem.parentNode.insertBefore(block, nextSibling)
									} else {
										insertAfterItem.parentNode.appendChild(block)
									}
								}
							} else {
								insertAfterItem.parentNode.appendChild(block)
							}
						}
					}
				}
			})

			entries
				.filter((e) => productItems.length < e.position)
				.forEach(({ block }) => {
					const lastItem = productItems[productItems.length - 1]
					if (lastItem && lastItem.parentNode) {
						lastItem.parentNode.appendChild(block)
					}
				})
		}

		setTimeout(updateSeparatorLines, 50)
	}

	function initCustomBlocksReorganizer() {
		if (!productGrid) {
			setTimeout(initCustomBlocksReorganizer, 100)
			return
		}

		let isTransitioning = false

		const observer = new MutationObserver(function (mutations) {
			let shouldReorganize = false
			mutations.forEach(function (mutation) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					const target = mutation.target
					if (target === productGrid) {
						const isChanging = target.classList.contains('ec-columns-changing')

						if (
							target.classList.contains('grid--2-col-desktop') ||
							target.classList.contains('grid--3-col-desktop')
						) {
							shouldReorganize = true
						}

						if (isChanging && !isTransitioning) {
							isTransitioning = true
							setTimeout(() => {
								reorganizeCustomBlocks()
								updateSeparatorLines()
							}, 100)
						} else if (!isChanging && isTransitioning) {
							isTransitioning = false
							setTimeout(() => {
								reorganizeCustomBlocks()
								updateSeparatorLines()
							}, 50)
						}
					}
				}
			})
			if (shouldReorganize && !isTransitioning) {
				setTimeout(() => {
					reorganizeCustomBlocks()
					updateSeparatorLines()
				}, 150)
			}
		})

		observer.observe(productGrid, {
			attributes: true,
			childList: true,
			subtree: true,
			attributeFilter: ['class'],
			attributeOldValue: false
		})

		setTimeout(() => {
			reorganizeCustomBlocks()
			updateSeparatorLines()
		}, 200)
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initCustomBlocksReorganizer)
	} else {
		setTimeout(initCustomBlocksReorganizer, 100)
	}

	function initLoadMore() {
		function updateButtonText(btn, remaining) {
			const textSpan = btn.querySelector('.ec-load-more-text')
			const template = btn.dataset.buttonTextTemplate || 'Mostrar mais {count} produtos'
			if (textSpan && remaining > 0) {
				textSpan.textContent = template.replace('{count}', remaining)
			}
		}

		function getCurrentProductIds(productGrid) {
			const productItems = productGrid.querySelectorAll('.grid__item:not(.ec-custom-block)')
			const ids = new Set()
			productItems.forEach((item) => {
				const productLink = item.querySelector('a[href*="/products/"]')
				if (productLink) {
					const href = productLink.getAttribute('href')
					const productHandle = href.split('/products/')[1]?.split('?')[0]?.split('#')[0]
					if (productHandle) {
						ids.add(productHandle)
					}
				}
			})
			return ids
		}

		document.addEventListener('click', async function (event) {
			const loadMoreBtn = event.target.closest('.ec-load-more-btn')
			if (!loadMoreBtn) return

			const productGrid = document.querySelector('#product-grid')
			if (!productGrid) return

			const currentPage = parseInt(loadMoreBtn.dataset.currentPage) || 1
			const totalPages = parseInt(loadMoreBtn.dataset.totalPages) || 1
			const sectionId = loadMoreBtn.dataset.sectionId
			const nextPage = currentPage + 1

			if (nextPage > totalPages) {
				const wrapper = loadMoreBtn.closest('.ec-load-more-wrapper')
				if (wrapper) {
					wrapper.remove()
				} else {
					loadMoreBtn.remove()
				}
				return
			}

			const textSpan = loadMoreBtn.querySelector('.ec-load-more-text')
			const spinner = loadMoreBtn.querySelector('.loading__spinner')
			const existingProductIds = getCurrentProductIds(productGrid)

			loadMoreBtn.disabled = true
			loadMoreBtn.classList.add('loading')
			if (spinner) spinner.classList.remove('hidden')

			try {
				const currentUrl = new URL(window.location.href)
				const searchParams = new URLSearchParams(currentUrl.search)
				searchParams.set('page', nextPage.toString())

				const sectionUrl = `${
					currentUrl.pathname
				}?section_id=${sectionId}&${searchParams.toString()}`

				const response = await fetch(sectionUrl)
				const html = await response.text()
				const parser = new DOMParser()
				const doc = parser.parseFromString(html, 'text/html')

				const newProductGrid = doc.querySelector('#product-grid')
				if (newProductGrid) {
					const allItems = Array.from(newProductGrid.querySelectorAll('.grid__item'))
					const newProducts = allItems.filter((item) => !item.classList.contains('ec-custom-block'))
					let addedCount = 0

					newProducts.forEach((product) => {
						const productLink = product.querySelector('a[href*="/products/"]')
						if (productLink) {
							const href = productLink.getAttribute('href')
							const productHandle = href.split('/products/')[1]?.split('?')[0]?.split('#')[0]

							if (productHandle && !existingProductIds.has(productHandle)) {
								const clonedProduct = product.cloneNode(true)
								productGrid.appendChild(clonedProduct)
								existingProductIds.add(productHandle)
								addedCount++
							}
						}
					})

					if (window.updateSeparatorLines) {
						setTimeout(() => window.updateSeparatorLines(), 100)
					}

					if (window.shopifyEcInitCardGalleriesIn) {
						window.shopifyEcInitCardGalleriesIn(productGrid)
					}

					if (typeof reorganizeCustomBlocks === 'function') {
						setTimeout(() => {
							reorganizeCustomBlocks()
						}, 150)
					}

					if (typeof initializeScrollAnimationTrigger === 'function') {
						initializeScrollAnimationTrigger(productGrid)
					}

					const totalProducts = parseInt(loadMoreBtn.dataset.totalProducts) || 0
					const currentProductCount = productGrid.querySelectorAll(
						'.grid__item:not(.ec-custom-block)'
					).length
					const remainingProducts = totalProducts - currentProductCount

					loadMoreBtn.dataset.currentPage = nextPage.toString()
					loadMoreBtn.dataset.currentProducts = currentProductCount.toString()

					if (nextPage >= totalPages || remainingProducts <= 0 || addedCount === 0) {
						const wrapper = loadMoreBtn.closest('.ec-load-more-wrapper')
						if (wrapper) {
							wrapper.remove()
						} else {
							loadMoreBtn.remove()
						}
					} else {
						updateButtonText(loadMoreBtn, remainingProducts)
						loadMoreBtn.dataset.remainingProducts = remainingProducts.toString()
						loadMoreBtn.disabled = false
						loadMoreBtn.classList.remove('loading')
					}
				}
			} catch (error) {
				console.error('Erro ao carregar mais produtos:', error)
				loadMoreBtn.disabled = false
				loadMoreBtn.classList.remove('loading')
				if (spinner) spinner.classList.add('hidden')
			} finally {
				loadMoreBtn.classList.remove('loading')
				if (spinner) spinner.classList.add('hidden')
			}
		})
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initLoadMore)
	} else {
		setTimeout(initLoadMore, 100)
	}
})();

